module.exports = __webpack_public_path__ + "img/car.9bb3a398.svg";